<template>
  <PortalBlock :portal-block="3"></PortalBlock>
</template>

<script>
import PortalBlock from "./components/PortalBlock.vue";

export default {
  name: "portal-instruments",
  components: {
    PortalBlock,
  },
};
</script>
